<template>
  <div class="mb-4">
    <div class="label">{{ label }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'input-control',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 700;
}
</style>
